export const userProfileList = ["administrador", "gerente", "cliente"];